export function toCompanyIconUrl(objectId?: string): string | undefined {
  const runtimeConfig = useRuntimeConfig()
  if (!objectId) {
    return undefined
  }
  const url = `${runtimeConfig.public.s3PublicBucket}${objectId}`
  return url
}

